unit SystemAccessRights.Settings;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Data.DB,
  WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client;

type
  TForm1 = class(TForm)
    WebPanel1: TPanel;
    wcUserAccess: TXDataWebClient;
    wdsUserAccess: TXDataWebDataSet;
    dsUserAccess: TDataSource;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  Form1: TForm1;

implementation

{$R *.dfm}

procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  wcUserAccess := TXDataWebClient.Create(Self);
  wdsUserAccess := TXDataWebDataSet.Create(Self);
  dsUserAccess := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  wcUserAccess.BeforeLoadDFMValues;
  wdsUserAccess.BeforeLoadDFMValues;
  dsUserAccess.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Width := 640;
    Height := 480;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 480;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 640;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'User Access Settings';
    WebPanel2.Color := clSilver;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 60;
    WebPanel3.Width := 640;
    WebPanel3.Height := 149;
    WebPanel3.Align := alTop;
    WebPanel3.ChildOrder := 1;
    WebPanel3.TabOrder := 1;
    wcUserAccess.SetParentComponent(Self);
    wcUserAccess.Name := 'wcUserAccess';
    wcUserAccess.Left := 560;
    wcUserAccess.Top := 21;
    wdsUserAccess.SetParentComponent(Self);
    wdsUserAccess.Name := 'wdsUserAccess';
    wdsUserAccess.Left := 560;
    wdsUserAccess.Top := 77;
    dsUserAccess.SetParentComponent(Self);
    dsUserAccess.Name := 'dsUserAccess';
    dsUserAccess.Left := 560;
    dsUserAccess.Top := 133;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    wcUserAccess.AfterLoadDFMValues;
    wdsUserAccess.AfterLoadDFMValues;
    dsUserAccess.AfterLoadDFMValues;
  end;
end;

end.